import DeactivateModal from './deactivate';

export default DeactivateModal;
